/**
 * Работа с подписью
 */

;
window.SK = (() => {
	"use strict";

	if (!window.PARAMS) {
		console.error('[SK] PARAMS.js не загружен до SignKit.js');
	}
	if (!window.getSignCert) {
		console.error('[SK] sign.js (getSignCert) не загружен до SignKit.js');
	}
	if (!window.HK) {
		console.error('[SK] HelpersKit.js не загружен до SignKit.js');
	}

	// ============================================
	// ПАРАМЕТРЫ
	// ============================================

	const _LEGACY_SIGN = true; // используем старые методы подписи вместо тех что описаны здесь !!!

	const API_ENDPOINT = "SignTools";
	const IS_USE_GOSKEY = PARAMS.isUseGosKey;
	const GOSKEY_EXPIRE_MINUTES = PARAMS.goskey_expire_minutes;

	const CADES_WAIT_TIMEOUT = 8000;      // ждём готовности cadesplugin
	const CADES_FAILED_TTL = 30000; // сколько помним, что плагина нет
	let cadesFailedAt = 0;          // время последней неудачи

	// ПАРАМЕТРЫ КРИПТО ПРО
	const getSignCert = window.getSignCert;

	/**
	 * Объект cadesplugin читаем в момент вызова, а не на этапе загрузки файла:
	 * cadesplugin_api.js теперь подгружается лениво (SK.CP.isPluginActive()),
	 * поэтому на момент выполнения этого файла window.cadesplugin еще не существует.
	 * @returns {object}
	 */
	const getSignPlugin = () => window.cadesplugin ?? {};
	const CAPICOM_PARAMS = {
		STORE_OPEN_READ_ONLY: 0,
		CURRENT_USER_STORE: 2,
		CERTIFICATE_FIND_SHA1_HASH: 0,
		CERTIFICATE_FIND_EXTENDED_PROPERTY: 6,
		CERTIFICATE_FIND_TIME_VALID: 9,
		CERTIFICATE_FIND_KEY_USAGE: 12,
		DIGITAL_SIGNATURE_KEY_USAGE: 0x00000080,
		AUTHENTICATED_ATTRIBUTE_SIGNING_TIME: 0,
		INFO_SUBJECT_SIMPLE_NAME: 0,
		ENCODE_BASE64: 0,
		E_CANCELLED: -2138568446,
		CERT_KEY_SPEC_PROP_ID: 6
	};


	// Коды ошибок
	const ErrorCodes = {
		CANCELLED: "CANCELLED", // Пользователь отменил подпись
		NO_AUTH: "NO_AUTH", // Нет авторизации
		NO_SIGN: "NO_SIGN", // Подпись не получена
		NETWORK: "NETWORK", // Ошибка сети
		TIMEOUT: "TIMEOUT", // вышло время подписания
		NO_PLUGIN: "NO_PLUGIN", // Отсутствует плагин КриптоПро
		UNKNOWN: "UNKNOWN", // Неизвестная ошибка
	};

	//	class Result {
	//		static ok(data) {
	//			return {success: true, data};
	//		}
	//		static err(error, code, meta = {}) {
	//			return {success: false, error, code, ...meta};
	//		}
	//		static cancel(message) {
	//			return Result.err(message, ErrorCodes.CANCELLED, {cancelled: true});
	//		}
	//	}

	// ============================================
	// UI - работа с DOM/диалогами
	// ============================================
	const UI = {
		showCover() {
			const cover = document.querySelector(".signCover");
			if (cover) {
				cover.style.display = "block";
			}

		},

		hideCover() {
			const cover = document.querySelector(".signCover");
			if (cover) {
				cover.style.display = "none";
				cover.classList.remove("forced");
			}
		},

		showGosKeyDialog(packageName) {
			if (typeof window.showGoskeySignDialog === "function") {
				window.showGoskeySignDialog(packageName);
			}
		},

		closeGosKeyDialog() {
			if (typeof window.closeGoskeySignDialog === "function") {
				window.closeGoskeySignDialog();
			}
		},

		showPluginDialog() {
			if (typeof window.pluginDialog === "function") {
				window.pluginDialog(1);
			}
		}
	};

	const CryptoProUtils = {
		/**
		 * Показываем подробный текст к ошибке подписи - 3542
		 * @param {type} type
		 * @returns {text}
		 */
		getErrorText(type) {
			switch (type) {
				case 'Ошибка при формировании подписи':
					{
						let text = 'Ошибка при формировании подписи! <br>Попробуйте обновить плагин КриптоПро по <a rel="nofollow" target="_blank" href="https://m-ets.ru/static/cadesplugin.exe">ссылке</a>';
						return text;
					}
				case 'Сертификаты не найдены':
					{
						let text = 'Сертификаты не найдены!<br><p>Вам необходимо установить УКЭП, запустив приложение КриптоПро CSP.<br><span style="display: block; margin-top: 5px;">В приложении выбираем:<br><b>"Сервис"</b> → <b>"Просмотреть сертификаты в контейнере"</b> → <b>"Обзор"</b>.<br>Затем необходимо выбрать Ваш сертификат, нажать <b>"Далее"</b> и <b>"Установить"</b></span></p>';
						return text;
					}
				default:
					{ // если что-то иное то возвращаем тоже самое
						return type;
					}
			}
		},

		GetErrorMessage(e) {
			var err = e.message;
			if (!err) {
				err = e;
			} else if (e.number) {
				err += " (0x" + HK.decimalToHexString(e.number) + ")";
			}
			return err;
		},

		/**
		 * Получить SURNAME из подписи
		 * @param {type} SN
		 * @returns {String}
		 */
		getSubjPartSurname(SN) {
			var rv = SN.replace(/(.+,\s|^)SN=(.*?)(,\s.*|$)/, "$2");
			return rv == SN ? "" : rv;
		},
		/**
		 * Получить GIVENNAME из подписи
		 * @param {type} SN
		 * @returns {String}
		 */
		getSubjPartGivenname(SN) {
			var rv = SN.replace(/(.+,\s|^)G=(.*?)(,\s.*|$)/, "$2");
			return rv == SN ? "" : rv;
		},
		/**
		 * Получить FIO из подписи
		 * @param {type} SN
		 * @returns {String}
		 */
		getSubjPartFIO(SN) {
			var rv = SN.replace(/(.+,\s|^)CN=(.*?)(,\s.*|$)/, "$2");
			return rv == SN ? "" : rv;
		},
		/**
		 * Получить Email из подписи
		 * @param {type} SN
		 * @returns {String}
		 */
		getSubjPartEmail(SN) {
			var rv = SN.replace(/(.+,\s|^)E=(.*?)(,\s.*|$)/, "$2");
			return rv == SN ? "" : rv;
		},
		/**
		 * Получить Loc из подписи
		 * @param {type} SN
		 * @returns {String}
		 */
		getSubjPartLoc(SN) {
			var rv = SN.replace(/(.+,\s|^)L=(.*?)(,\s.*|$)/, "$2");
			return rv == SN ? "" : rv;
		},
		/**
		 * Получить Org из подписи
		 * @param {type} SN
		 * @returns {String}
		 */
		getSubjPartOrg(SN) {
			var rv = SN.replace(/(.+,\s|^)O=(.*?)(,\s.*|$)/, "$2");
			return rv == SN ? "" : rv;
		},
		/**
		 * Получить dolz из подписи
		 * @param {type} SN
		 * @returns {String}
		 */
		getSubjPartDolzh(SN) {
			var rv = SN.replace(/(.+,\s|^)T=(.*?)(,\s.*|$)/, "$2");
			return rv == SN ? "" : rv;
		},

		/**
		 * Получить partAd из подписи
		 * @param {type} SN
		 * @returns {String}
		 */
		getSubjPartAddress(SN) {
			var rv = SN.replace(/(.+,\s|^)S=(.*?)(,\s.*|$)/, "$2");
			return rv == SN ? "" : rv;
		},
		/**
		 * Получить inn из подписи
		 * @param {type} SN
		 * @returns {String}
		 */
		getSubjPartInn(SN) {
			var rv = SN.replace(/(.+,\s|^)(INNLE|OID.1.2.643.100.4|ИНН ЮЛ)=(.*?)(,\s.*|$)/, "$3");
			if (rv != SN) {
				return rv;
			}

			var rv = SN.replace(/(.+,\s|^)(ИНН|INN)=(.*?)(,\s.*|$)/, "$3");
			if (rv != SN) {
				if (rv.length === 12 && rv.substring(0, 2) === "00") {
					rv = rv.substring(2);
				}
				return rv;
			}
			return "";
		},
	};

	// ============================================
	// CryptoPro - работа с сертификатами
	// ============================================
	const CryptoPro = {
		_lastUsedCert: null, // последний использованный сертификат



		clearCertificate() {
			this._lastUsedCert = null;
			localStorage.removeItem('__storedSelectedCertsV2'); // удаляем ошибочный сертификат из хранилища
		},

		/**
		 * Получить сертификат (через существующий диалог)
		 * ВСЕГДА возвращает результат
		 */
		async getCertificate(useSelected = true) {
			if (this._lastUsedCert && useSelected) {
				return { success: true, cert: this._lastUsedCert };
			}

			if (typeof getSignCert !== "function") {
				return { success: false, error: "getSignCert не найден", code: ErrorCodes.UNKNOWN };
			}

			try {
				const cert = await getSignCert();

				if (!cert) {
					// Диалог закрыт или сертификаты не найдены
					return { success: false, cancelled: true, code: ErrorCodes.CANCELLED };
				}

				this._lastUsedCert = cert;
				return { success: true, cert };
			} catch (e) {
				return { success: false, error: e.message, code: ErrorCodes.UNKNOWN };
			}
		},

		/**
		 * Создать подпись CAdES
		 */
		async createSignature(cert, data, isFile = true, isBase64 = true) {
			const plugin = getSignPlugin();

			if (typeof plugin.CreateObjectAsync !== "function") {
				return { success: false, error: "Плагин КриптоПро не готов (cadesplugin не загружен)", code: ErrorCodes.NO_PLUGIN };
			}

			try {
				const oSigner = await plugin.CreateObjectAsync("CAdESCOM.CPSigner");
				if (!oSigner) {
					return { success: false, error: "Failed to create CAdESCOM.CPSigner", code: ErrorCodes.UNKNOWN };
				}

				await oSigner.propset_Certificate(cert);

				const oSignedData = await plugin.CreateObjectAsync("CAdESCOM.CadesSignedData");

				let txtDataToSign = data;

				if (!isFile) {
					if (!isBase64) {
						await oSignedData.propset_ContentEncoding(0);
					} else {
						await oSignedData.propset_ContentEncoding(1);
						txtDataToSign = HK.base64_encode(data);
					}
				} else {
					if (!isBase64) {
						txtDataToSign = HK.base64_encode(data);
					}
					await oSignedData.propset_ContentEncoding(1);
				}

				await oSignedData.propset_Content(txtDataToSign);
				await oSigner.propset_Options(1); // CAPICOM_CERTIFICATE_INCLUDE_WHOLE_CHAIN

				const CADES_BES = 1;
				const signature = await oSignedData.SignCades(oSigner, CADES_BES, isFile);

				return { success: true, signature };
			} catch (e) {
				const errorMsg = typeof plugin.getLastError === "function"
					? plugin.getLastError(e)
					: e.message;
				return { success: false, error: errorMsg, code: ErrorCodes.UNKNOWN };
			}
		},

		/**
		 * Подпись через КриптоПро
		 */
		async sign(docBase64, useSelectedCert = true) {
			// Проверяем плагин
			if (!CryptoPro.checkPlugin()) {
				UI.showPluginDialog();
				return { success: false, cancelled: true, error: "Плагин не установлен", code: ErrorCodes.NO_PLUGIN };
			}

			// Получаем сертификат
			const certResult = await CryptoPro.getCertificate(useSelectedCert);

			if (!certResult.success) {
				return {
					success: false,
					cancelled: certResult.cancelled,
					error: certResult.error || "Сертификат не выбран",
					code: certResult.code || ErrorCodes.CANCELLED
				};
			}

			UI.showCover();

			try {
				const signResult = await CryptoPro.createSignature(certResult.cert, docBase64, true, true);

				UI.hideCover();

				if (!signResult.success) {
					CryptoPro.clearCertificate();
					return signResult;
				}

				return { success: true, signature: signResult.signature };

			} catch (e) {
				UI.hideCover();
				CryptoPro.clearCertificate();
				return { success: false, error: e.message, code: ErrorCodes.UNKNOWN };
			}
		},

		checkPlugin() {
			return typeof hasPlugin !== "undefined" && hasPlugin;
		},

		// Неактуально

		// _isCadesScriptLoaded() {
		// 	return HK.isLazyScriptLoaded('cadesplugin');
		// },

		// async _loadCadesScript() {
		// 	await HK.lazyLoadScript('cadesplugin', '/js/styles/blue/cadesplugin_api.js');
		// },

		// /**
		//  * Ждём фактической готовности плагина, а не только загрузки скрипта.
		//  * Готовность = resolve промиса window.cadesplugin: внутри cadesplugin_api.js
		//  * расширение сначала вызывает cadesplugin.set(pluginObject) и только затем plugin_loaded() (resolve).
		//  * Флаг hasPlugin взводится РАНЬШЕ — в cadesplugin_extension_loaded_callback, сразу после загрузки скрипта расширения,
		//  * поэтому опираться на него нельзя: иначе CreateObjectAsync вызывается в момент,
		//  * когда pluginObject ещё undefined (Cannot read properties of undefined).
		//  * @returns {Promise<boolean>}
		//  */
		// _waitForCadesPlugin(timeout = CADES_WAIT_TIMEOUT) {
		// 	const plugin = window.cadesplugin;

		// 	if (plugin && typeof plugin.then === 'function') {
		// 		return new Promise((resolve) => {
		// 			let done = false;
		// 			let timer = null;
		// 			const finish = (v) => {
		// 				if (done) {
		// 					return;
		// 				};
		// 				done = true;
		// 				clearTimeout(timer);
		// 				resolve(v);
		// 			};

		// 			timer = setTimeout(() => finish(false), timeout);

		// 			plugin.then(() => {
		// 				cadesFailedAt = 0;
		// 				window.hasPlugin = true;
		// 				finish(true);
		// 			}, () => finish(false)); // plugin_loaded_error: плагин не готов
		// 		});
		// 	}

		// 	// фолбек для браузеров без Promise / без cadesplugin
		// 	if (this.checkPlugin()) {
		// 		return Promise.resolve(true);
		// 	}

		// 	return new Promise((resolve) => {
		// 		const startedAt = Date.now();
		// 		const tick = () => {
		// 			if (typeof hasPlugin !== "undefined" && hasPlugin) return resolve(true);
		// 			if (Date.now() - startedAt >= timeout) return resolve(false);
		// 			setTimeout(tick, 100);
		// 		};
		// 		tick();
		// 	});
		// },

		// /**
		//  * Гарантирует: скрипт загружен и плагин реально готов.
		//  * @returns {Promise<boolean>}
		//  */
		// async isPluginActive() {
		// 	if (cadesFailedAt && Date.now() - cadesFailedAt < CADES_FAILED_TTL) {
		// 		return false; // недавно уже выяснили, что плагина нет
		// 	}

		// 	if (!this._isCadesScriptLoaded()) {
		// 		try {
		// 			await MoK.load.withLoading(
		// 				() => this._loadCadesScript(),
		// 				{ text: "Загрузка…", delay: 200 }
		// 			);
		// 		} catch (e) {
		// 			console.error('cadesplugin_api.js не загрузился', e);
		// 			return false;
		// 		}
		// 	}

		// 	const isActive = await MoK.load.withLoading(
		// 		() => this._waitForCadesPlugin(),
		// 		{ text: "Проверка работы плагина КриптоПро…", delay: 200 }
		// 	);

		// 	if (!isActive) {
		// 		cadesFailedAt = Date.now();
		// 	}

		// 	return isActive;
		// },
	};

	// ============================================
	// GosKey - подписание через ГосКлюч
	// ============================================
	const GosKey = {
		/**
		 * Отправить файлы на подпись в ГосКлюч
		 */
		async sendFilesToGosKey(files, snils) {
			const formData = new FormData();
			formData.append("op", "sendsignfiles");

			if (snils) {
				formData.append("snils", snils);
			}

			for (let i = 0; i < files.length; i++) {
				formData.append("file_" + i, files[i]);
			}

			const res = await fetch(API_ENDPOINT, {
				method: "POST",
				body: formData
			});

			if (!res.ok) {
				return { success: false, error: `HTTP ${res.status}`, code: ErrorCodes.NETWORK };
			}

			const data = await res.json();
			const orderId = data?.orderId || data?.result?.orderId;

			if (!orderId) {
				return {
					success: false,
					error: data?.message || "Ошибка отправки данных в Госключ",
					code: ErrorCodes.NETWORK
				};
			}

			return { success: true, orderId, packageName: data.packageName };
		},

		/**
		 * Проверить статус подписи ГосКлюч
		 */
		async checkGosKeyOrder(orderId, type) {
			const url = `${API_ENDPOINT}?op=checkOrder&id=${orderId}${type ? "&type=" + type : ""}`;
			const res = await fetch(url);

			if (!res.ok) {
				return { success: false, error: `HTTP ${res.status}`, code: ErrorCodes.NETWORK };
			}

			return await res.json();
		},

		/**
		 * Подготовить файл из base64
		 */
		prepareFile(docBase64, docName, fileInfo) {
			const bstr = atob(docBase64);
			const u8arr = new Uint8Array(bstr.length);
			for (let i = 0; i < bstr.length; i++) {
				u8arr[i] = bstr.charCodeAt(i);
			}

			const fileName = typeof docName.toGoskeyFileName === "function" ? docName.toGoskeyFileName() : docName;

			return new File([u8arr], fileName, { type: fileInfo?.type || "application/octet-stream" });
		},

		/**
		 * Ожидание результата подписи (polling)
		 */
		async waitForSignature(orderId, type) {
			const startTime = performance.now();
			const timeoutMinutes = GOSKEY_EXPIRE_MINUTES; // таймаут в минутах
			const timeoutMs = timeoutMinutes * 60 * 1000;

			while (true) {
				const elapsed = performance.now() - startTime;

				if (elapsed >= timeoutMs) {
					return {
						success: false,
						error: "Истекло время подписания документов",
						code: ErrorCodes.TIMEOUT
					};
				}

				try {
					const result = await this.checkGosKeyOrder(orderId, type);

					if (result.statusId === 3 && result.signData) {
						// Успех
						return { success: true, signData: result.signData };
					}

					if (result.statusId === 4) {
						// Отменено пользователем
						return {
							success: false,
							cancelled: true,
							error: result.statusName || "Подпись отменена",
							code: ErrorCodes.CANCELLED
						};
					}

					if (result.statusId === 5) {
						// Ошибка
						return {
							success: false,
							error: result.statusName || "Ошибка подписания",
							code: ErrorCodes.UNKNOWN
						};
					}

					// statusId 1, 2 - в процессе, ждем
					await new Promise(resolve => setTimeout(resolve, 1000));

				} catch (e) {
					return { success: false, error: "Ошибка получения данных", code: ErrorCodes.NETWORK };
				}
			}
		},

		/**
		 * Подпись через ГосКлюч
		 */
		async sign(docBase64, docName, fileInfo, snils) {
			const file = this.prepareFile(docBase64, docName, fileInfo);
			const files = [file];

			UI.showCover();

			try {
				// Отправляем файлы
				const sendResult = await this.sendFilesToGosKey(files, snils);

				if (!sendResult.success) {
					UI.hideCover();
					return sendResult;
				}

				// Показываем диалог ожидания
				UI.showGosKeyDialog(sendResult.packageName);

				// Ждем результат
				const waitResult = await this.waitForSignature(sendResult.orderId);

				UI.closeGosKeyDialog();
				UI.hideCover();

				if (!waitResult.success) {
					return waitResult;
				}

				// Извлекаем подпись для нашего файла
				const fileName = typeof file.name.toGoskeyFileName === "function"
					? file.name.toGoskeyFileName()
					: file.name;

				const signature = waitResult.signData?.[fileName];

				if (!signature) {
					return { success: false, error: "Подпись не получена", code: ErrorCodes.NO_SIGN };
				}

				return { success: true, signature };

			} catch (e) {
				UI.closeGosKeyDialog();
				UI.hideCover();
				return { success: false, error: e.message, code: ErrorCodes.UNKNOWN };
			}
		}
	};


	// ============================================
	// FixedDoc - Подписание документа, хранящегося на сервере
	// ============================================
	const FixedDoc = {
		/**
		 * Получает документ для подписи с сервера (base64)
		 */
		async getFixed(docName) {
			const url = `${API_ENDPOINT}?op=getfixed&name=${encodeURIComponent(docName)}`;

			try {
				const res = await fetch(url);

				if (!res.ok) {
					return { success: false, error: `HTTP ${res.status}`, code: ErrorCodes.NETWORK };
				}

				const data = await res.text();

				if (data === "noauth") {
					return { success: false, error: "noauth", code: ErrorCodes.NO_AUTH, needAuth: true };
				}

				return { success: true, data };
			} catch (e) {
				return { success: false, error: e.message, code: ErrorCodes.NETWORK };
			}
		},

		/**
		 * Сохраняет подпись документа на сервере
		 */
		async saveFixed(docName, signature, useGosKey = false) {
			try {
				const formData = new FormData();
				formData.append("sign", signature);
				formData.append("op", "savefixed");
				formData.append("name", docName);

				if (useGosKey) {
					formData.append("useGosKey", "true");
				}

				const res = await fetch(API_ENDPOINT, {
					method: "POST",
					body: formData
				});

				if (!res.ok) {
					return { success: false, error: `HTTP ${res.status}`, code: ErrorCodes.NETWORK };
				}

				const data = await res.json();

				if (!data?.file_id) {
					return { success: false, error: "Некорректный ответ сервера", code: ErrorCodes.UNKNOWN };
				}

				return {
					success: true,
					data: {
						file_id: data.file_id,
						file_info: data.file_info,
						file_size: data.file_size
					}
				};
			} catch (e) {
				return { success: false, error: e.message, code: ErrorCodes.NETWORK };
			}
		},

		/**
		 * Полный цикл подписания фиксированного документа
		 * 1. Получает документ с сервера
		 * 2. Подписывает (через Sign или SignGosKeyFiles)
		 * 3. Сохраняет подпись на сервере
		 *
		 * @param {string} docName - имя документа
		 * @returns {Promise<{success: boolean, cancelled?: boolean, data?: {file_id: number, file_info: string, file_size: number}, error?: string, code?: string}>}
		 */
		async sign(docName) {
			// 1. Получаем документ
			const getResult = await this.getFixed(docName);

			if (!getResult.success) {
				return getResult;
			}

			const docBase64 = getResult.data;

			// 2. Подписываем документ
			let signResult;

			try {
				if (IS_USE_GOSKEY) { // Подпись через ГосКлюч

					const fileInfo = window.FK?.getFileExtension(docName);

					if (fileInfo?.gosKeyAllowed === false) {
						return {
							success: false,
							error: "Подписание данного типа документа не поддерживается Госключем",
							code: ErrorCodes.UNKNOWN
						};
					}

					if (_LEGACY_SIGN) {  // СТАРЫЙ МЕТОД ПОДПИСИ c колбеками
						signResult = await new Promise((resolve) => {
							const bstr = atob(docBase64);
							const u8arr = new Uint8Array(bstr.length);
							for (let i = 0; i < bstr.length; i++)
								u8arr[i] = bstr.charCodeAt(i);

							const fileName = typeof docName.toGoskeyFileName === "function" ? docName.toGoskeyFileName() : docName;
							const file = new File([u8arr], fileName, { type: fileInfo?.type || "application/octet-stream" });

							// Вызов старой функции
							SignGosKeyFiles([file], function (signData) {
								if (!signData || typeof signData !== "object") {
									resolve({ success: false, cancelled: true, error: "Подписание отменено или не получено", code: ErrorCodes.CANCELLED });
									return;
								}
								const signature = signData[fileName];
								if (!signature) {
									resolve({ success: false, error: "Подпись не получена", code: ErrorCodes.NO_SIGN });
								} else {
									resolve({ success: true, signature });
								}
							});
						});
					} else {
						signResult = await GosKey.sign(docBase64, docName, fileInfo);
					}


				} else { // Подпись через КриптоПро

					if (_LEGACY_SIGN) {  // СТАРЫЙ МЕТОД ПОДПИСИ c колбеками

						signResult = await Sign(docBase64, true, true);
						if (!signResult) {
							return { success: false, cancelled: true, error: "Подписание отменено", code: ErrorCodes.CANCELLED };
						} else {
							signResult = ({ success: true, signature: signResult });
						}
					} else {
						signResult = await CryptoPro.sign(docBase64);
					}
				}

				PARAMS.isStage && console.log(signResult, 'signResult [signKit fixedDoc]')

				if (!signResult.success) {
					return signResult;
				}

				// 3. Сохраняем подпись
				const saveResult = await this.saveFixed(docName, signResult.signature, IS_USE_GOSKEY);

				if (!saveResult.success) {
					CryptoPro.clearCertificate();
				}

				return saveResult;
			} catch (e) {
				// Проверяем, была ли это отмена пользователем
				if (e.code === ErrorCodes.CANCELLED) {
					return { success: false, cancelled: true, error: e.message, code: ErrorCodes.CANCELLED };
				}
				PARAMS.isStage && console.error(e, 'signResult [signKit fixedDoc]')
				return { success: false, error: e.message || "Ошибка при подписании документа", code: ErrorCodes.UNKNOWN };
			}
		},
	};

	//
	//	// ============================================
	//	// UploadedFile - Подписание загруженного файла по ID
	//	// ============================================
	//	const UploadedFile = {
	//		/**
	//		 * Получить файл с сервера по ID (base64)
	//		 */
	//		async getUploaded(id) {
	//			const url = `${API_ENDPOINT}?op=getuploaded&id=${id}`;
	//
	//			try {
	//				const res = await fetch(url);
	//
	//				if (!res.ok) {
	//					return {success: false, error: `HTTP ${res.status}`, code: ErrorCodes.NETWORK};
	//				}
	//
	//				const data = await res.text();
	//
	//				if (!data || data.length === 0) {
	//					return {success: false, error: `Невозможно скачать файл ИД ${id}`, code: ErrorCodes.NETWORK};
	//				}
	//
	//				return {success: true, data};
	//			} catch (e) {
	//				return {success: false, error: e.message, code: ErrorCodes.NETWORK};
	//			}
	//		},
	//
	//		/**
	//		 * Сохранить подпись файла на сервере
	//		 */
	//		async saveSignature(id, signature) {
	//			try {
	//				const formData = new FormData();
	//				formData.append("op", "signuploaded");
	//				formData.append("id", id);
	//				formData.append("sign", signature);
	//
	//				const res = await fetch(API_ENDPOINT, {
	//					method: "POST",
	//					body: formData
	//				});
	//
	//				if (!res.ok) {
	//					return {success: false, error: `HTTP ${res.status}`, code: ErrorCodes.NETWORK};
	//				}
	//
	//				const data = await res.json();
	//
	//				if (data?.success) {
	//					return {success: true};
	//				}
	//
	//				return {
	//					success: false,
	//					error: data?.message || "Неизвестная ошибка при подписании файла",
	//					code: ErrorCodes.UNKNOWN
	//				};
	//			} catch (e) {
	//				return {success: false, error: e.message, code: ErrorCodes.NETWORK};
	//			}
	//		},
	//
	//		/**
	//		 * Полный цикл подписания загруженного файла
	//		 * @param {number|string} id - ID файла
	//		 * @returns {Promise<{success: boolean, error?: string, code?: string}>}
	//		 */
	//		async sign(id) {
	//			// 1. Получаем файл
	//			const getResult = await this.getUploaded(id);
	//
	//			if (!getResult.success) {
	//				return getResult;
	//			}
	//
	//			// 2. Подписываем через КриптоПро (useSelectedCert = true для повторных подписей)
	//			const signResult = await CryptoPro.sign(getResult.data, true);
	//
	//			if (!signResult.success) {
	//				return signResult;
	//			}
	//
	//			// 3. Сохраняем подпись
	//			return await this.saveSignature(id, signResult.signature);
	//		}
	//	};
	//
	//	// ============================================
	//	// FormValidation - Валидация полей формы
	//	// ============================================
	//	const FormValidation = {
	//		/**
	//		 * Валидация даты в формате dd.mm.yyyy
	//		 */
	//		validateDate(s, error = {}) {
	//			const separators = ['\\.'];
	//			const bits = s.split(new RegExp(separators.join('|'), 'g'));
	//			const d = new Date(bits[2], bits[1] - 1, bits[0]);
	//			const ret = d.getFullYear() == bits[2] && d.getMonth() + 1 == bits[1];
	//
	//			if (ret) {
	//				return true;
	//			}
	//
	//			error.message = "Неверный формат даты!";
	//			return false;
	//		},
	//
	//		/**
	//		 * Проверка полей формы
	//		 * @param {string} formId - ID формы
	//		 * @param {boolean} silent - не показывать алерты
	//		 * @returns {boolean}
	//		 */
	//		checkFormFields(formId, silent = false) {
	//			const form = document.getElementById(formId);
	//			if (!form)
	//				return false;
	//
	//			let isValid = true;
	//			let firstInvalidEl = null;
	//
	//			const showAlert = (msg, el) => {
	//				if (!silent && typeof aAlert === "function") {
	//					aAlert(msg).then(() => {
	//						if (el)
	//							el.focus();
	//					});
	//				}
	//			};
	//
	//			// Проверка дат
	//			form.querySelectorAll("input.datepicker:not([style*='display: none'])").forEach(el => {
	//				const val = el.value;
	//				if (val && !this.validateDate(val)) {
	//					if (!firstInvalidEl)
	//						firstInvalidEl = el;
	//					isValid = false;
	//				}
	//			});
	//
	//			if (!isValid) {
	//				showAlert("Неправильный формат даты!", firstInvalidEl);
	//				return false;
	//			}
	//
	//			// Тримминг текстовых полей
	//			form.querySelectorAll("input[type=text]").forEach(el => {
	//				el.blur();
	//				if (typeof el.value === "string") {
	//					el.value = el.value.trim().replace(/\s+/g, ' ');
	//				}
	//			});
	//
	//			// Проверка обязательных чекбоксов
	//			form.querySelectorAll("[required][type=checkbox]:not(:checked)").forEach(el => {
	//				if (!firstInvalidEl)
	//					firstInvalidEl = el;
	//				isValid = false;
	//			});
	//
	//			if (!isValid) {
	//				showAlert("Не все обязательные галочки поставлены!", firstInvalidEl);
	//				return false;
	//			}
	//
	//			// Проверка inputmask
	//			if (typeof jQuery !== "undefined" && jQuery.fn.inputmask) {
	//				jQuery(`#${formId} input[inputmask]:visible`).each(function (i, el) {
	//					if (!jQuery(el).inputmask("isComplete") && jQuery(el).val() !== "") {
	//						if (!firstInvalidEl)
	//							firstInvalidEl = el;
	//						isValid = false;
	//					}
	//				});
	//			}
	//
	//			// Проверка required полей
	//			form.querySelectorAll("[required]").forEach(el => {
	//				if (!el.value) {
	//					if (!firstInvalidEl)
	//						firstInvalidEl = el;
	//					isValid = false;
	//				}
	//			});
	//
	//			// Проверка required_hidden полей
	//			form.querySelectorAll("[required_hidden]").forEach(el => {
	//				if (!el.value) {
	//					if (!firstInvalidEl)
	//						firstInvalidEl = el;
	//					isValid = false;
	//				}
	//			});
	//
	//			if (!isValid) {
	//				showAlert("Не все обязательные поля заполнены!", firstInvalidEl);
	//				return false;
	//			}
	//
	//			// Проверка числовых полей
	//			const numFields = form.querySelectorAll("[isnum]");
	//			for (const el of numFields) {
	//				const val = el.value.replace(/ /gi, "").replace(",", ".");
	//				if (isNaN(val)) {
	//					showAlert("Неверное число!", el);
	//					return false;
	//				}
	//
	//				const type = el.getAttribute("isnum");
	//				if ((type === "natural" || type === "real") && val <= 0 && val !== "") {
	//					showAlert("Нулевое значение недопустимо!", el);
	//					return false;
	//				}
	//			}
	//
	//			// Проверка обязательных файлов .filereq
	//			const fileReqs = form.querySelectorAll(".filereq:not([style*='display: none'])");
	//			for (const div of fileReqs) {
	//				const attfiles = div.querySelectorAll(".attfile:not(.removed)");
	//				if (attfiles.length === 0) {
	//					const titleEl = div.querySelector(".filetitle");
	//					const title = titleEl ? titleEl.innerHTML : "";
	//					showAlert(`<div>Приложите документы:<br>${title}</div>`);
	//					return false;
	//				}
	//			}
	//
	//			// Проверка file_required
	//			let fileMsg = "Не все требуемые файлы приложены!";
	//			const fileRequiredEls = form.querySelectorAll("[file_required]:not([disabled])");
	//			for (const el of fileRequiredEls) {
	//				if (!el.value) {
	//					if (el.getAttribute("data-miss-title")) {
	//						fileMsg = el.getAttribute("data-miss-title");
	//					}
	//					showAlert(fileMsg);
	//					return false;
	//				}
	//			}
	//
	//			return true;
	//		}
	//	};
	//
	//	// ============================================
	//	// FormSigner - Подпись и отправка форм
	//	// ============================================
	//	const FormSigner = {
	//		/**
	//		 * Подпись данных формы и отправка
	//		 * @param {string} data - текст для подписи
	//		 * @param {string} formId - ID формы
	//		 * @param {Function} onSignCallback - колбек после подписи (опционально)
	//		 */
	//		async signSendForm(data, formId, onSignCallback) {
	//			const form = document.getElementById(formId);
	//
	//			if (!form) {
	//				if (typeof aAlert === "function")
	//					await aAlert("No form!");
	//				return {success: false, error: "No form", code: ErrorCodes.UNKNOWN};
	//			}
	//
	//			if (!form.sign) {
	//				if (typeof aAlert === "function")
	//					await aAlert("Bad form!");
	//				return {success: false, error: "Bad form - no sign field", code: ErrorCodes.UNKNOWN};
	//			}
	//
	//			// Проверяем загрузку файлов
	//			if (typeof UPLOAD_FILS !== "undefined" && !UPLOAD_FILS.isDone()) {
	//				if (typeof aAlert === "function")
	//					await aAlert("Дождитесь окончание загрузки файлов.");
	//				return {success: false, error: "Files uploading", code: ErrorCodes.UNKNOWN};
	//			}
	//
	//			const formName = form.getAttribute("data-form-name") || "Форма заявки";
	//			const formFile = formName + ".txt";
	//
	//			// Собираем дополнительные тексты для подписи (data-sign2-text, data-sign3-text и т.д.)
	//			const additionalSignTexts = [];
	//			for (let n = 2; n < 99; n++) {
	//				const signText = form.getAttribute(`data-sign${n}-text`);
	//				if (typeof signText === "undefined" || signText === null)
	//					break;
	//
	//				const signName = form.getAttribute(`data-sign${n}-name`) || `text_${n}`;
	//				additionalSignTexts.push({
	//					n,
	//					text: signText,
	//					filename: signName + ".txt"
	//				});
	//			}
	//
	//			// Собираем прикрепленные файлы
	//			const attachedFiles = {};
	//			const attachFilesInput = form.querySelector("input[name='attach_files']");
	//
	//			if (attachFilesInput?.value) {
	//				const fileIds = attachFilesInput.value.split(",");
	//
	//				for (const fileId of fileIds) {
	//					const attFileElements = form.querySelectorAll(".attfile.new");
	//					for (const attFile of attFileElements) {
	//						const attFileInput = attFile.querySelector(`input[type="hidden"][value="${fileId}"]`);
	//						if (!attFileInput)
	//							continue;
	//
	//						const fileLink = attFile.querySelector(".filecap .title");
	//						if (fileLink) {
	//							const fileUrl = fileLink.getAttribute("href");
	//							const fileName = fileLink.textContent.trim();
	//
	//							try {
	//								const response = await fetch(fileUrl);
	//								const blob = await response.blob();
	//								attachedFiles[fileName] = {
	//									fileId,
	//									blob,
	//									mimeType: blob.type || "text/plain"
	//								};
	//							} catch (e) {
	//								console.error(`Ошибка при загрузке файла ${fileName}:`, e);
	//							}
	//						}
	//						break;
	//					}
	//				}
	//			}
	//
	//			if (IS_USE_GOSKEY) {
	//				// ===== Подпись через ГосКлюч =====
	//				const dt = new DataTransfer();
	//
	//				// Основная форма
	//				const mainFile = new File([data], formFile, {type: "text/plain"});
	//				dt.items.add(mainFile);
	//
	//				// Дополнительные тексты
	//				for (const item of additionalSignTexts) {
	//					if (item.text) {
	//						const file = new File([item.text], item.filename, {type: "text/plain"});
	//						dt.items.add(file);
	//					}
	//				}
	//
	//				// Прикрепленные файлы
	//				const attachedFileNames = {};
	//				for (const [fileName, fileData] of Object.entries(attachedFiles)) {
	//					// Проверка на дубликаты
	//					if (attachedFileNames[fileName]) {
	//						if (typeof aAlert === "function") {
	//							await aAlert(`ГосКлюч не поддерживает подписание нескольких файлов с идентичными названиями. Переименуйте файл ${fileName}.`);
	//						}
	//						return {success: false, error: "Duplicate file names", code: ErrorCodes.UNKNOWN};
	//					}
	//
	//					attachedFileNames[fileName] = fileData.fileId;
	//					const file = new File([fileData.blob], fileName, {type: fileData.mimeType});
	//					dt.items.add(file);
	//				}
	//
	//				// Отправляем все файлы в ГосКлюч
	//				UI.showCover();
	//
	//				const sendResult = await GosKey.sendFilesToGosKey(dt.files);
	//
	//				if (!sendResult.success) {
	//					UI.hideCover();
	//					return sendResult;
	//				}
	//
	//				UI.showGosKeyDialog(sendResult.packageName);
	//
	//				const waitResult = await GosKey.waitForSignature(sendResult.orderId);
	//
	//				UI.closeGosKeyDialog();
	//				UI.hideCover();
	//
	//				if (!waitResult.success) {
	//					return waitResult;
	//				}
	//
	//				// Распределяем подписи по полям формы
	//				const signData = waitResult.signData;
	//
	//				// Основная форма
	//				const mainFileName = typeof formFile.toGoskeyFileName === "function"
	//					? formFile.toGoskeyFileName()
	//					: formFile;
	//				form.sign.value = signData[mainFileName] || "";
	//
	//				// Прикрепленные файлы
	//				for (const [fileName, fileId] of Object.entries(attachedFileNames)) {
	//					const gkFileName = typeof fileName.toGoskeyFileName === "function"
	//						? fileName.toGoskeyFileName()
	//						: fileName;
	//					if (signData[gkFileName]) {
	//						let signInput = form[`sign_attach_file_${fileId}`];
	//						if (!signInput) {
	//							signInput = document.createElement("INPUT");
	//							signInput.type = "hidden";
	//							signInput.name = `sign_attach_file_${fileId}`;
	//							form.appendChild(signInput);
	//						}
	//						signInput.value = signData[gkFileName];
	//					}
	//				}
	//
	//				// Дополнительные тексты
	//				for (const item of additionalSignTexts) {
	//					const gkFileName = typeof item.filename.toGoskeyFileName === "function"
	//						? item.filename.toGoskeyFileName()
	//						: item.filename;
	//					if (signData[gkFileName]) {
	//						let signInput = form[`sign${item.n}`];
	//						if (!signInput) {
	//							signInput = document.createElement("INPUT");
	//							signInput.type = "hidden";
	//							signInput.name = `sign${item.n}`;
	//							form.appendChild(signInput);
	//						}
	//						signInput.value = signData[gkFileName];
	//					}
	//				}
	//
	//				// Добавляем флаг useGosKey
	//				if (!form.useGosKey) {
	//					const input = document.createElement("INPUT");
	//					input.type = "hidden";
	//					input.name = "useGosKey";
	//					input.value = "true";
	//					form.appendChild(input);
	//				}
	//
	//			} else {
	//				// ===== Подпись через КриптоПро =====
	//				let useSelectedCert = false;
	//
	//				// Сначала подписываем дополнительные тексты
	//				for (const item of additionalSignTexts) {
	//					if (item.text) {
	//						const signResult = await CryptoPro.sign(item.text, useSelectedCert);
	//						if (!signResult.success) {
	//							return signResult;
	//						}
	//
	//						let signInput = form[`sign${item.n}`];
	//						if (!signInput) {
	//							signInput = document.createElement("INPUT");
	//							signInput.type = "hidden";
	//							signInput.name = `sign${item.n}`;
	//							form.appendChild(signInput);
	//						}
	//						signInput.value = signResult.signature;
	//						useSelectedCert = true;
	//					}
	//				}
	//
	//				// Подписываем основную форму
	//				const mainSignResult = await CryptoPro.sign(data, useSelectedCert);
	//
	//				if (!mainSignResult.success) {
	//					return mainSignResult;
	//				}
	//
	//				form.sign.value = mainSignResult.signature;
	//			}
	//
	//			// Отправляем форму
	//			if (typeof onSignCallback === "function") {
	//				onSignCallback();
	//			} else {
	//				form.onsubmit = "";
	//				form.submit();
	//			}
	//
	//			return {success: true};
	//		},
	//
	//		/**
	//		 * Подпись формы с валидацией и проверкой на сервере
	//		 * @param {string} formId - ID формы
	//		 * @param {string} formName - имя формы
	//		 * @param {string} checkUrl - URL для проверки (опционально)
	//		 * @param {boolean} noSign - отправить без подписи
	//		 * @param {Function} onSign - колбек после подписи
	//		 */
	//		async signForm(formId, formName, checkUrl, noSign = false, onSign) {
	//			const form = document.getElementById(formId);
	//
	//			if (!form) {
	//				if (typeof aAlert === "function")
	//					await aAlert("No form!");
	//				return {success: false, error: "No form"};
	//			}
	//
	//			// Проверка confirm диалога
	//			const confirmText = form.getAttribute("data-confirm");
	//			if (confirmText && typeof aConfirm === "function") {
	//				const confirmed = await aConfirm(confirmText);
	//				if (!confirmed) {
	//					return {success: false, cancelled: true};
	//				}
	//			}
	//
	//			// Валидация полей
	//			if (!FormValidation.checkFormFields(formId)) {
	//				return {success: false, error: "Validation failed"};
	//			}
	//
	//			// Проверка на сервере
	//			let dataToSign;
	//
	//			if (checkUrl) {
	//				try {
	//					const formData = new FormData(form);
	//					formData.append('check', '1');
	//
	//					const res = await fetch(checkUrl, {
	//						method: 'POST',
	//						body: formData
	//					});
	//
	//					if (!res.ok) {
	//						if (typeof aAlert === "function")
	//							await aAlert("Ошибка!");
	//						return {success: false, error: `HTTP ${res.status}`};
	//					}
	//
	//					const data = await res.json();
	//
	//					if (data.noauth) {
	//						if (data.act === "bid" && typeof showAuthDialog === "function") {
	//							// Сохраняем параметры для повторной подписи после авторизации
	//							window.signFormParams = {formId, formName, checkUrl};
	//							showAuthDialog();
	//							return {success: false, error: "noauth", needAuth: true};
	//						}
	//						if (data.act === "auth" && typeof showAuthDialog === "function") {
	//							showAuthDialog();
	//							return {success: false, error: "noauth", needAuth: true};
	//						}
	//						if (data.act === "alert") {
	//							if (typeof aAlert === "function")
	//								await aAlert("Вы не авторизованы!");
	//							return {success: false, error: "noauth"};
	//						}
	//					}
	//
	//					if (data.errors) {
	//						if (typeof aAlert === "function")
	//							await aAlert(data.errors);
	//						return {success: false, error: data.errors};
	//					}
	//
	//					// Обработка прикрепленных файлов
	//					if (data.attachFiles) {
	//						let attachFilesInput = form.querySelector("input[name='attach_files']");
	//						if (!attachFilesInput) {
	//							attachFilesInput = document.createElement("input");
	//							attachFilesInput.type = "hidden";
	//							attachFilesInput.name = "attach_files";
	//							form.appendChild(attachFilesInput);
	//						}
	//						attachFilesInput.value = data.attachFiles;
	//					}
	//
	//					// Предупреждения
	//					if (data.warnings && typeof aConfirm === "function") {
	//						const confirmed = await aConfirm(data.warnings + "<br>Продолжить?");
	//						if (!confirmed) {
	//							return {success: false, cancelled: true};
	//						}
	//					}
	//
	//					dataToSign = IS_USE_GOSKEY ? data.text : data.form_txt;
	//
	//				} catch (e) {
	//					if (typeof aAlert === "function")
	//						await aAlert("Ошибка!");
	//					return {success: false, error: e.message};
	//				}
	//			} else {
	//				// Без checkUrl - запрашиваем текст для подписи
	//				try {
	//					const res = await fetch(`SignTools?formname=${formName}`, {
	//						method: 'POST',
	//						body: new URLSearchParams(new FormData(form))
	//					});
	//
	//					const data = await res.json();
	//
	//					if (data.errors) {
	//						if (typeof aAlert === "function")
	//							await aAlert(data.errors);
	//						return {success: false, error: data.errors};
	//					}
	//
	//					dataToSign = IS_USE_GOSKEY ? data.text : data.form_txt;
	//
	//				} catch (e) {
	//					if (typeof aAlert === "function")
	//						await aAlert("Ошибка!");
	//					return {success: false, error: e.message};
	//				}
	//			}
	//
	//			// Отправка без подписи
	//			if (noSign) {
	//				form.submit();
	//				return {success: true};
	//			}
	//
	//			// Подписываем и отправляем
	//			return await this.signSendForm(dataToSign, formId, onSign);
	//		},
	//
	//		/**
	//		 * Проверка формы и отправка (без подписи)
	//		 */
	//		async checkForm(formId, formName, checkUrl, isOper = false) {
	//			// Проверка загрузки файлов
	//			if (typeof UPLOAD_FILS !== "undefined" && !UPLOAD_FILS.isDone()) {
	//				if (typeof aAlert === "function")
	//					await aAlert("Дождитесь окончание загрузки файлов.");
	//				return false;
	//			}
	//
	//			// Валидация
	//			if (!isOper && !FormValidation.checkFormFields(formId)) {
	//				return false;
	//			}
	//
	//			if (checkUrl) {
	//				try {
	//					const form = document.getElementById(formId);
	//					const res = await fetch(`${checkUrl}?check=1`, {
	//						method: 'POST',
	//						body: new URLSearchParams(new FormData(form))
	//					});
	//
	//					const data = await res.json();
	//
	//					if (isOper && (data.errors || data.warnings)) {
	//						const msg = (data.errors ? "<b>Ошибки:</b><br>" + data.errors + "<br>" : "") +
	//							(data.warnings ? "<b>Предупреждения:</b><br>" + data.warnings + "<br>" : "") +
	//							"<span style='margin-top:15px'>Сохранить изменения?</span>";
	//
	//						if (typeof aConfirm === "function") {
	//							const confirmed = await aConfirm(msg);
	//							if (confirmed) {
	//								form.onsubmit = "";
	//								form.submit();
	//								return true;
	//							}
	//						}
	//						return false;
	//					}
	//
	//					if (data.errors) {
	//						if (typeof aAlert === "function")
	//							await aAlert(data.errors);
	//						return false;
	//					}
	//
	//					form.onsubmit = "";
	//					form.submit();
	//					return true;
	//
	//				} catch (e) {
	//					if (typeof aAlert === "function")
	//						await aAlert("Ошибка!");
	//					return false;
	//				}
	//			}
	//
	//			return true;
	//		},
	//
	//		/**
	//		 * Предпросмотр формы
	//		 */
	//		async previewForm(formId, formName) {
	//			try {
	//				const form = document.getElementById(formId);
	//				const res = await fetch("SignTools?fromname=xx", {
	//					method: 'POST',
	//					body: new URLSearchParams(new FormData(form))
	//				});
	//
	//				const data = await res.text();
	//				const w = window.open("about:blank");
	//
	//				if (typeof aAlert === "function") {
	//					await aAlert(data);
	//				}
	//
	//				w.document.write(data);
	//				return {success: true};
	//
	//			} catch (e) {
	//				return {success: false, error: e.message};
	//			}
	//		}
	//	};
	//
	//	// ============================================
	//	// ProtoSigner - Подпись протоколов
	//	// ============================================
	//	const ProtoSigner = {
	//		/**
	//		 * Подпись всех протоколов в таблице
	//		 */
	//		async signAllProto() {
	//			const table = document.getElementById("prototable");
	//
	//			if (!table) {
	//				if (typeof aAlert === "function") {
	//					await aAlert("No table!");
	//				}
	//
	//				return {success: false, error: "No table"};
	//			}
	//
	//			const tds = Array.from(document.querySelectorAll(".prottd"));
	//
	//			if (tds.length === 0) {
	//				return {success: false, error: "No protocols to sign"};
	//			}
	//
	//			let errors = 0;
	//			const MAX_ERRORS = 10;
	//
	//			// Показываем диалог ожидания
	//			if (typeof jQuery !== "undefined" && jQuery("#waitDialog").dialog) {
	//				jQuery("#waitDialog").dialog("open");
	//			}
	//
	//			for (let i = 0; i < tds.length; i++) {
	//				const td = tds[i];
	//				const lot = td.getAttribute("lot");
	//
	//				// Проверяем, не был ли файл заменён
	//				const replacedInput = document.querySelector(`input[name=replaced${lot}]`);
	//				if (replacedInput?.value) {
	//					this._log(i + 1, "Пропущен (заменён)");
	//					continue;
	//				}
	//
	//				this._log(i + 1, "Подписываем...");
	//
	//				const link = document.getElementById(`a${lot}`);
	//				if (!link)
	//					continue;
	//
	//				const href = link.href + "&base64";
	//
	//				try {
	//					// Получаем документ
	//					const res = await fetch(href);
	//					const data = await res.text();
	//
	//					if (data === "noauth") {
	//						if (typeof aAlert === "function") {
	//							await aAlert("Ошибка сессии! Необходима авторизация!");
	//						}
	//						if (typeof showPostAuthDialog === "function") {
	//							showPostAuthDialog();
	//						}
	//						this._closeDialog();
	//						return {success: false, error: "noauth", needAuth: true};
	//					}
	//
	//					// Подписываем
	//					const signResult = await CryptoPro.sign(data, true); // useSelectedCert = true
	//
	//					if (!signResult.success) {
	//						if (typeof aAlert === "function") {
	//							await aAlert("Ошибка при подписывании протоколов!");
	//						}
	//						this._closeDialog();
	//						return signResult;
	//					}
	//
	//					// Сохраняем подпись в форму
	//					const signInput = document.getElementById(`sign${lot}`);
	//					if (signInput) {
	//						signInput.value = signResult.signature;
	//					}
	//
	//					this._log(i + 1, "Готово!");
	//
	//				} catch (e) {
	//					this._log(i + 1, "ОШИБКА ПОЛУЧЕНИЯ!");
	//					errors++;
	//
	//					if (errors > MAX_ERRORS) {
	//						if (typeof aAlert === "function") {
	//							await aAlert("Ошибка при подписывании протоколов!");
	//						}
	//						this._closeDialog();
	//						return {success: false, error: "Too many errors"};
	//					}
	//
	//					// Повторяем текущий протокол
	//					i--;
	//				}
	//			}
	//
	//			this._closeDialog();
	//
	//			// Отправляем форму
	//			const protoform = document.getElementById("protoform");
	//			if (protoform) {
	//				protoform.submit();
	//			}
	//
	//			return {success: true};
	//		},
	//
	//		_log(num, msg) {
	//			const logEl = document.getElementById("protolog");
	//			if (logEl) {
	//				logEl.innerHTML += `Подписываем протокол №${num}...${msg}<br>`;
	//				logEl.scrollTop = 99999999;
	//			}
	//		},
	//
	//		_closeDialog() {
	//			if (typeof jQuery !== "undefined" && jQuery("#waitDialog").dialog) {
	//				jQuery("#waitDialog").dialog("close");
	//			}
	//		}
	//	};

	// то, что будет доступно снаружи
	const publicAPI = {
		CP: CryptoPro,
		FixedDoc: FixedDoc.sign.bind(FixedDoc),
		ErrorCodes,
	};

	return publicAPI;
})();
